export function getUrl() {
  const base = (() => {
    if (typeof window !== 'undefined') return '';
    if (process.env.NEXT_PUBLIC_BASE_URL)
      return `https://${process.env.NEXT_PUBLIC_BASE_URL}`;
    return `http://localhost:${process.env.PORT ?? 3001}`;
  })();
  return `${base}/api/trpc`;
}
